import { render, staticRenderFns } from "./MerchantCredit.vue?vue&type=template&id=6868b8d0&scoped=true&"
import script from "./MerchantCredit.vue?vue&type=script&lang=js&"
export * from "./MerchantCredit.vue?vue&type=script&lang=js&"
import style0 from "./MerchantCredit.vue?vue&type=style&index=0&id=6868b8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6868b8d0",
  null
  
)

export default component.exports